import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const whatsappNumber = '34667459830';
  const whatsappMessage = encodeURIComponent('Hola, me gustaría obtener más información sobre sus armarios a medida.');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/05d084940ee954a0cfb237d427bdcdae.jpg',
      title: 'Diseño sin límites',
      subtitle: 'Armarios que definen tu espacio'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Spacious%20luxury%20walk%20in%20closet%20dressing%20room%20with%20white%20lacquered%20shelves%20LED%20strip%20lighting%20organized%20clothing%20display%20marble%20floor%20golden%20accents%20contemporary%20home%20interior%20professional%20real%20estate%20photography%20bright%20and%20airy%20atmosphere&width=1920&height=1080&seq=202&orientation=landscape',
      title: 'Elegancia a medida',
      subtitle: 'Cada detalle pensado para ti'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20floor%20to%20ceiling%20built%20in%20storage%20system%20oak%20wood%20finish%20integrated%20bookshelf%20and%20cabinet%20combination%20sleek%20handle%20less%20design%20natural%20daylight%20streaming%20through%20large%20windows%20Scandinavian%20inspired%20interior%20professional%20photo&width=1920&height=1080&seq=203&orientation=landscape',
      title: 'Calidad premium',
      subtitle: 'Fabricación artesanal española'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Stunning%20master%20bedroom%20with%20full%20wall%20mirrored%20sliding%20closet%20doors%20reflecting%20city%20skyline%20at%20twilight%20dramatic%20evening%20lighting%20plush%20bed%20dark%20charcoal%20and%20gold%20color%20scheme%20ultra%20modern%20penthouse%20interior%20cinematic%20professional%20photography&width=1920&height=1080&seq=204&orientation=landscape',
      title: 'Innovación constante',
      subtitle: 'Tecnología y diseño unidos'
    }
  ];

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsTransitioning(false);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index: number) => {
    if (index !== currentSlide) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide(index);
        setIsTransitioning(false);
      }, 500);
    }
  };

  const products = [
    {
      title: 'Armarios Corredera',
      description: 'Sistemas deslizantes de máxima suavidad y diseño',
      image: 'https://benno-design-studio.lovable.app/assets/armarios-corredera-BZcgMxQQ.jpg',
      link: '/productos/armarios-corredera'
    },
    {
      title: 'Armarios Abatibles',
      description: 'Apertura clásica con acabados premium',
      image: 'https://benno-design-studio.lovable.app/assets/armario-abatible-CYOheyuu.jpg'
    },
    {
      title: 'Armarios Plegables',
      description: 'Soluciones versátiles para cualquier espacio',
      image: 'https://benno-design-studio.lovable.app/assets/armarios-plegables-T-JJjHKj.jpg'
    },
    {
      title: 'Modelo Expression',
      description: 'Líneas puras y contemporáneas',
      image: 'https://benno-design-studio.lovable.app/assets/expression-zoaGXKmP.jpg'
    },
    {
      title: 'Modelo Millenium',
      description: 'Vanguardia y sofisticación',
      image: 'https://benno-design-studio.lovable.app/assets/millenium-_3bubT5B.jpg'
    },
    {
      title: 'Separación de Ambientes',
      description: 'Divide sin cerrar, decora sin límites',
      image: 'https://benno-design-studio.lovable.app/assets/separacion-ambientes-BMDjy3eC.jpg'
    },
    {
      title: 'Interiores de Armarios',
      description: 'Organización inteligente a medida',
      image: 'https://benno-design-studio.lovable.app/assets/interiores-armarios-B4g1ybcP.jpg'
    },
    {
      title: 'Benno Diseño Puertas',
      description: 'Puertas de paso con personalidad',
      image: 'https://benno-design-studio.lovable.app/assets/puertas-CzixEhFt.jpg'
    },
    {
      title: 'Marcando la Diferencia',
      description: 'Innovación que nos distingue',
      image: 'https://benno-design-studio.lovable.app/assets/marcando-BRkAs2ks.jpg'
    }
  ];

  const qualities = [
    {
      icon: 'ri-shield-check-line',
      title: 'Garantía 5 años',
      description: 'Garantizamos rodamientos, frenos, bisagras y guías de baldas durante 5 años por escrito.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Fabricación propia',
      description: 'Cada armario se fabrica a medida en nuestras instalaciones con los más altos estándares de calidad.'
    },
    {
      icon: 'ri-star-line',
      title: 'Materiales Premium',
      description: 'Seleccionamos los mejores materiales del mercado para ofrecer durabilidad y elegancia.'
    },
    {
      icon: 'ri-ruler-2-line',
      title: 'A medida',
      description: 'Cada proyecto es único. Diseñamos y fabricamos según las necesidades exactas de tu espacio.'
    }
  ];

  const configSteps = [
    { number: '01', title: 'Tipo de puerta', description: 'Corredera, abatible o plegable' },
    { number: '02', title: 'Materiales', description: 'Cristal, madera, lacado, combinados' },
    { number: '03', title: 'Acabados', description: 'Colores y texturas a tu gusto' },
    { number: '04', title: 'Medidas', description: 'Adapta al milímetro tu espacio' }
  ];

  const [activeStep, setActiveStep] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d672jt6d937i0243n34g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/95 backdrop-blur-md border-b border-amber-500/20' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <a href="#inicio" className="flex items-center gap-2">
            <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-16 w-auto" />
          </a>
          <div className="hidden lg:flex items-center gap-2">
            <a href="#inicio" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Inicio</a>
            <a href="#nosotros" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Nosotros</a>
            <a href="#servicios" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Servicios</a>
            <a href="#portfolio" className="px-5 py-2 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-amber-400">Portfolio</a>
            <a href="#contacto" className="px-6 py-2.5 text-base font-semibold transition-all duration-300 bg-gradient-to-r from-amber-500 to-amber-600 text-black rounded shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer">Contacto</a>
          </div>
          <button
            className="lg:hidden cursor-pointer text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-amber-500/20">
            <div className="px-6 py-4 space-y-2">
              <a href="#inicio" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Inicio</a>
              <a href="#nosotros" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Nosotros</a>
              <a href="#servicios" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Servicios</a>
              <a href="#portfolio" className="block px-4 py-3 text-base font-semibold text-white hover:text-amber-400 cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Portfolio</a>
              <a href="#contacto" className="block px-4 py-3 text-base font-semibold bg-gradient-to-r from-amber-500 to-amber-600 text-black rounded text-center cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Contacto</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="relative h-screen overflow-hidden">
        {/* Background Images */}
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-black"></div>

        <div className={`relative z-10 h-full flex flex-col items-center justify-center text-center px-6 transition-opacity duration-500 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}>
          <div>
            <h1 className="font-bold text-5xl md:text-7xl lg:text-8xl text-white mb-4">
              {slides[currentSlide].title}
            </h1>
            <p className="text-lg md:text-xl text-amber-500/80 mb-8 tracking-wide">
              {slides[currentSlide].subtitle}
            </p>
            <div className="flex gap-4 justify-center">
              <a href="#portfolio" className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-semibold text-sm tracking-wider uppercase shadow-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer">
                Ver productos
              </a>
              <a href="#servicios" className="px-8 py-3 border border-amber-500/50 text-amber-500 font-semibold text-sm tracking-wider uppercase hover:bg-amber-500/10 transition-colors whitespace-nowrap cursor-pointer">
                Configurador
              </a>
            </div>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`cursor-pointer transition-all duration-300 ${index === currentSlide ? 'w-8 h-2 bg-amber-500 rounded-full' : 'w-2 h-2 bg-white/30 rounded-full hover:bg-amber-500/50'}`}
              aria-label={`Ir a slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={() => goToSlide((currentSlide - 1 + slides.length) % slides.length)}
          className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center border border-amber-500/30 rounded-full text-amber-500 hover:bg-amber-500/10 hover:border-amber-500 transition-all cursor-pointer"
          aria-label="Slide anterior"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          onClick={() => goToSlide((currentSlide + 1) % slides.length)}
          className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center border border-amber-500/30 rounded-full text-amber-500 hover:bg-amber-500/10 hover:border-amber-500 transition-all cursor-pointer"
          aria-label="Siguiente slide"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        {/* Progress Bar */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/5 z-20">
          <div
            className="h-full bg-gradient-to-r from-amber-500 to-amber-600 transition-all duration-100"
            style={{
              width: '100%',
              animation: 'progressBar 5s linear infinite'
            }}
          />
        </div>
      </section>

      {/* About Section */}
      <section id="nosotros" className="py-24 px-6 bg-neutral-950">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-24">
            <div>
              <span className="text-amber-500 text-sm tracking-[0.3em] uppercase">Sobre nosotros</span>
              <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 mb-6">Armarios Benno</h2>
              <p className="text-gray-400 leading-relaxed mb-4">
                ÁLJURSON SL – <strong className="text-amber-500">Armarios Benno</strong>, nació en 1998 ante la necesidad, que percibían sus socios, de innovar el mundo del armario empotrado. Hasta esa fecha, el armario había sido considerado un mero complemento que se mimetizaba en el ambiente haciéndolo coincidir con las puertas de paso de la habitación.
              </p>
              <p className="text-gray-400 leading-relaxed mb-6">
                Pero siendo conscientes del <strong className="text-amber-500">importante espacio</strong> que ocupa un armario en cualquier estancia, hemos apostado por dotar a dichos armarios de una identidad propia que consiga reflejar la personalidad de cada cliente.
              </p>
              <div className="flex items-center gap-4">
                <div className="text-center">
                  <span className="text-4xl font-bold bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">20+</span>
                  <span className="block text-xs text-gray-500 mt-1">Años de experiencia</span>
                </div>
                <div className="w-px h-12 bg-amber-500/30"></div>
                <img src="https://benno-design-studio.lovable.app/assets/sello-garantia-D1ls3dIw.png" alt="Garantía 5 años" className="h-16 opacity-70" />
              </div>
            </div>
            <div className="relative">
              <img
                src="https://benno-design-studio.lovable.app/assets/edificio-benno-CkSFkSXw.jpg"
                alt="Instalaciones Armarios Benno"
                className="w-full rounded-sm"
              />
              <div className="absolute inset-0 border border-amber-500/30 rounded-sm translate-x-4 translate-y-4 -z-10"></div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1 flex justify-center">
              <img
                src="https://benno-design-studio.lovable.app/assets/kaizen-CKetAbWI.jpg"
                alt="Kaizen"
                className="w-48 opacity-60"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h3 className="text-3xl font-bold text-white mb-2">Filosofía KAIZEN</h3>
              <p className="text-amber-500 italic text-lg mb-4">"Hoy mejor que ayer, mañana mejor que hoy"</p>
              <p className="text-gray-400 leading-relaxed">
                "Cambio para mejorar" o "mejora continua". En la cultura japonesa está implantado el concepto de que ningún día debe pasar sin una cierta mejora. Esta es nuestra filosofía aplicada a cada armario que fabricamos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-24 px-6 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-amber-500 text-sm tracking-[0.3em] uppercase">Excelencia</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-3">Calidades</h2>
            <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mt-6"></div>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {qualities.map((quality, index) => (
              <div key={index} className="group text-center p-8 border border-amber-500/20 rounded-sm bg-neutral-950/50 hover:border-amber-500/50 transition-all duration-500 hover:shadow-lg hover:shadow-amber-500/5">
                <div className="w-14 h-14 mx-auto mb-6 flex items-center justify-center border border-amber-500/30 rounded-full group-hover:bg-amber-500/10 transition-colors duration-500">
                  <i className={`${quality.icon} text-2xl text-amber-500`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{quality.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{quality.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-24 px-6 bg-neutral-950 relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent via-amber-500/40 to-transparent"></div>
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
            <div>
              <span className="text-amber-500 text-xs tracking-[0.4em] uppercase font-medium">Colección</span>
              <h2 className="text-4xl md:text-6xl font-bold text-white mt-3 leading-tight">
                Nuestros<br />
                <span className="bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">Productos</span>
              </h2>
            </div>
            <p className="text-gray-500 text-sm max-w-sm leading-relaxed">
              Diseño, calidad y fabricación a medida. Descubre cada línea de producto pensada para transformar tu hogar.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2" data-product-shop>
            {products.map((product, index) => (
              <div key={index}>
                {product.link ? (
                  <Link to={product.link} className="group relative block overflow-hidden aspect-[4/5] rounded-sm cursor-pointer">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <div className="flex items-end justify-between">
                        <div>
                          <h3 className="text-lg font-semibold text-white leading-tight mb-1">{product.title}</h3>
                          <p className="text-xs text-amber-500/80 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                            {product.description}
                          </p>
                        </div>
                        <div className="w-8 h-8 rounded-full border border-amber-500/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 shrink-0 ml-3 group-hover:bg-amber-500/10">
                          <i className="ri-arrow-right-line text-amber-500"></i>
                        </div>
                      </div>
                    </div>
                    <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </Link>
                ) : (
                  <a className="group relative block overflow-hidden aspect-[4/5] rounded-sm cursor-pointer">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <div className="flex items-end justify-between">
                        <div>
                          <h3 className="text-lg font-semibold text-white leading-tight mb-1">{product.title}</h3>
                          <p className="text-xs text-amber-500/80 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                            {product.description}
                          </p>
                        </div>
                        <div className="w-8 h-8 rounded-full border border-amber-500/30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 shrink-0 ml-3 group-hover:bg-amber-500/10">
                          <i className="ri-arrow-right-line text-amber-500"></i>
                        </div>
                      </div>
                    </div>
                    <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Configurator Section */}
      <section id="configurador" className="py-24 px-6 bg-black relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/3 rounded-full blur-3xl"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-16">
            <span className="text-amber-500 text-sm tracking-[0.3em] uppercase">Personaliza</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-3">Configura tu Armario</h2>
            <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
              Diseña el armario perfecto para tu hogar. Elige tipo, materiales, acabados y medidas para crear una solución única.
            </p>
            <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mt-6"></div>
          </div>
          <div className="grid md:grid-cols-4 gap-6 mb-12">
            {configSteps.map((step, index) => (
              <button
                key={index}
                onClick={() => setActiveStep(index)}
                className={`p-6 rounded-sm text-left transition-all duration-500 cursor-pointer whitespace-nowrap ${activeStep === index
                  ? 'border border-amber-500 bg-amber-500/10 shadow-lg shadow-amber-500/10'
                  : 'border border-amber-500/20 bg-neutral-950/50 hover:border-amber-500/40'
                  }`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-amber-500 text-2xl font-bold">{step.number}</span>
                </div>
                <h3 className="text-lg font-bold text-white mb-1">{step.title}</h3>
                <p className="text-sm text-gray-500">{step.description}</p>
              </button>
            ))}
          </div>
          <div className="text-center">
            <a href="#contacto" className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold text-sm tracking-wider uppercase shadow-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer">
              Solicitar presupuesto
            </a>
            <p className="text-xs text-gray-600 mt-4">Te remitiremos al distribuidor más cercano</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-24 px-6 bg-neutral-950">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-amber-500 text-sm tracking-[0.3em] uppercase">Contacto</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-3">¿Te ayudamos?</h2>
            <p className="text-gray-500 mt-4 max-w-xl mx-auto">
              Si tienes alguna consulta, no dudes, ponte en contacto con nosotros y te remitiremos al distribuidor más cercano.
            </p>
            <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mt-6"></div>
          </div>
          <div className="grid lg:grid-cols-2 gap-16">
            <div className="space-y-8">
              <div className="flex gap-4 items-start">
                <div className="w-12 h-12 flex items-center justify-center border border-amber-500/30 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-500 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-white">Ubicación</h4>
                  <p className="text-sm text-gray-500 mt-1">Calle Escayolistas 13 - 28891 Velilla de San Antonio, Madrid</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-12 h-12 flex items-center justify-center border border-amber-500/30 rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-amber-500 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-white">Teléfono</h4>
                  <p className="text-sm text-gray-500 mt-1">91 791 933</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-12 h-12 flex items-center justify-center border border-amber-500/30 rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-amber-500 text-xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-white">Email</h4>
                  <p className="text-sm text-gray-500 mt-1">info@armariosbenno.com</p>
                </div>
              </div>
            </div>
            <form className="space-y-4" data-readdy-form id="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="nombre"
                placeholder="Nombre"
                className="w-full px-4 py-3 bg-black border border-amber-500/20 text-white text-sm placeholder:text-gray-600 focus:border-amber-500 focus:outline-none transition-colors rounded-sm"
                required
              />
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="w-full px-4 py-3 bg-black border border-amber-500/20 text-white text-sm placeholder:text-gray-600 focus:border-amber-500 focus:outline-none transition-colors rounded-sm"
                  required
                />
                <input
                  type="tel"
                  name="telefono"
                  placeholder="Teléfono"
                  className="w-full px-4 py-3 bg-black border border-amber-500/20 text-white text-sm placeholder:text-gray-600 focus:border-amber-500 focus:outline-none transition-colors rounded-sm"
                />
              </div>
              <textarea
                name="mensaje"
                placeholder="Tu mensaje..."
                rows={5}
                maxLength={500}
                className="w-full px-4 py-3 bg-black border border-amber-500/20 text-white text-sm placeholder:text-gray-600 focus:border-amber-500 focus:outline-none transition-colors resize-none rounded-sm"
                required
              ></textarea>
              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-black font-semibold text-sm tracking-wider uppercase shadow-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {formStatus === 'submitting' ? 'Enviando...' : 'Enviar mensaje'}
              </button>
              {formStatus === 'success' && (
                <div className="bg-neutral-900 border border-amber-500/30 rounded-sm p-6 text-center">
                  <img 
                    src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" 
                    alt="Armarios Benno" 
                    className="h-12 mx-auto mb-4"
                  />
                  <div className="w-12 h-12 mx-auto mb-4 bg-amber-500/20 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-amber-500 text-2xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">¡Mensaje enviado con éxito!</h4>
                  <p className="text-gray-400 text-sm mb-4">
                    Gracias por contactar con nosotros. Hemos recibido tu mensaje y te responderemos lo antes posible.
                  </p>
                  <p className="text-amber-500 text-sm font-medium">Equipo Benno</p>
                </div>
              )}
              {formStatus === 'error' && (
                <div className="bg-neutral-900 border border-red-500/30 rounded-sm p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 bg-red-500/20 rounded-full flex items-center justify-center">
                    <i className="ri-close-line text-red-500 text-2xl"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white mb-2">Error al enviar</h4>
                  <p className="text-gray-400 text-sm">
                    Ha ocurrido un error al enviar tu mensaje. Por favor, inténtalo de nuevo o contáctanos directamente por teléfono.
                  </p>
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-amber-500/20 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            <div className="flex items-center gap-4">
              <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-12 w-auto" />
              <div className="flex items-center gap-3">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
              <a href="#inicio" className="hover:text-amber-500 transition-colors cursor-pointer">Inicio</a>
              <a href="#nosotros" className="hover:text-amber-500 transition-colors cursor-pointer">Nosotros</a>
              <a href="#servicios" className="hover:text-amber-500 transition-colors cursor-pointer">Servicios</a>
              <a href="#portfolio" className="hover:text-amber-500 transition-colors cursor-pointer">Portfolio</a>
              <a href="#contacto" className="hover:text-amber-500 transition-colors cursor-pointer">Contacto</a>
            </div>
            <p className="text-xs text-gray-600 text-right">
              © 2025 Todos los derechos reservados.
            </p>
          </div>
          <div className="mt-8 pt-6 border-t border-amber-500/10 flex flex-col items-center gap-4">
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-600">
              <Link to="/politica-privacidad" className="hover:text-amber-500 transition-colors cursor-pointer">Política de Privacidad</Link>
              <span className="text-amber-500/30">|</span>
              <Link to="/politica-cookies" className="hover:text-amber-500 transition-colors cursor-pointer">Política de Cookies</Link>
              <span className="text-amber-500/30">|</span>
              <Link to="/aviso-legal" className="hover:text-amber-500 transition-colors cursor-pointer">Aviso Legal</Link>
            </div>
            <a className="text-xs text-gray-600 hover:text-amber-500 transition-colors cursor-pointer" href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer">
              Realizado por grupo Globaltis
            </a>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/34667459830?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
        <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          ¿Te ayudamos?
        </span>
      </a>
    </div>
  );
};

export default HomePage;
